module.exports = __webpack_public_path__ + "img/collect-a-sample.f1a96fd8.jpg";